/**
 * Сравнение версий клиента (CLIENT_WEB.md §9.5 п. 6).
 * Сравнение именно semver, без лексикографики: «1.10.0» новее «1.9.0».
 */
export function compareSemver(a: string, b: string): number {
  const parse = (value: string): number[] =>
    value
      .replace(/^v/, '')
      .split('-')[0]!
      .split('.')
      .map((part) => Number.parseInt(part, 10) || 0)

  const left = parse(a)
  const right = parse(b)

  for (let i = 0; i < 3; i += 1) {
    const diff = (left[i] ?? 0) - (right[i] ?? 0)
    if (diff !== 0) return diff < 0 ? -1 : 1
  }
  return 0
}
